export var EMPTY_DATE = '';
export var DATE_LENGTH = 8;
export var RANGE_DELIMETER = ' - ';
export var RU_FORMAT_PATTERN = /^(?<day>[0-9]{2}).(?<month>[0-9]{2}).(?<year>[0-9]{4}.*)$/;
export var ISO_FORMAT_PATTERN = /^(?<year>[0-9]{4})-(?<month>[0-9]{2})-(?<day>[0-9]{2}.*)$/;
export var isRangeMode = function (value) {
    return Array.isArray(value);
};
export var isFilledDate = function (value, options) {
    if (options === void 0) { options = {}; }
    var _a = options.pattern, pattern = _a === void 0 ? ISO_FORMAT_PATTERN : _a, _b = options.isPartial, isPartial = _b === void 0 ? false : _b;
    if (isRangeMode(value)) {
        return isPartial
            ? value.some(function (date) { return date && pattern.test(date); })
            : value.every(function (date) { return date && pattern.test(date); });
    }
    return pattern.test(value);
};
export var isEmptyDate = function (value) {
    if (isRangeMode(value)) {
        return !value.join('');
    }
    return !value;
};
export var formatDateToISO = function (value) {
    var formatToISO = function (date) {
        var _a = RU_FORMAT_PATTERN.exec(date).groups, day = _a.day, month = _a.month, year = _a.year;
        return year + "-" + month + "-" + day;
    };
    return value && formatToISO(value);
};
export var formatDatesToISO = function (value) {
    return isRangeMode(value) ? value.map(formatDateToISO) : formatDateToISO(value);
};
export var formatDateToLocale = function (value) {
    var formatToLocale = function (date) {
        var _a = ISO_FORMAT_PATTERN.exec(date).groups, year = _a.year, month = _a.month, day = _a.day;
        return day + "." + month + "." + year;
    };
    return isRangeMode(value)
        ? value.map(function (date) { return date && formatToLocale(date); })
        : value && formatToLocale(value);
};
export var getInputValue = function (value) {
    if (isRangeMode(value)) {
        var delimeter = isEmptyDate(value) ? EMPTY_DATE : RANGE_DELIMETER;
        return value
            .map(function (v) {
            if (v !== EMPTY_DATE)
                return new Date(v).toLocaleDateString('ru');
            return EMPTY_DATE;
        })
            .join(delimeter);
    }
    return value ? new Date(value).toLocaleDateString('ru') : EMPTY_DATE;
};
export var maskDate = function (value) {
    var date = value.replace(/\D/g, '').slice(0, DATE_LENGTH);
    if (date.length >= 5) {
        return date.slice(0, 2) + "." + date.slice(2, 4) + "." + date.slice(4);
    }
    if (date.length >= 3) {
        return date.slice(0, 2) + "." + date.slice(2);
    }
    return date;
};
